/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import { Text } from 'src/onboarding/components/typography/Text/Text';

function Page() {
  const dailySteps = useStore((state) => state.dailySteps);
  const setDailySteps = useStore((state) => state.setDailySteps);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.dailySteps.title')}</Title>
        <Text size='m' medium className='description'>
          {t('onboarding.dailySteps.subTitle')}
        </Text>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={dailySteps}
          onChange={(value) => {
            setDailySteps(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'daily-steps',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Less than 3,000 steps'}>
            <span>🪑</span> {t('onboarding.dailySteps.options.3000')}
          </Option>
          <Option value={'3,000–7,000 steps'}>
            <span>🚶</span> {t('onboarding.dailySteps.options.7000')}
          </Option>
          <Option value={'7,000–12,000 steps'}>
            <span>🏃</span> {t('onboarding.dailySteps.options.12000')}
          </Option>
          <Option value={'More than 12,000 steps'}>
            <span>🥇</span> {t('onboarding.dailySteps.options.more')}
          </Option>
          <Option value={'I’m not sure'}>
            <span>🤷</span> {t('onboarding.dailySteps.options.notSure')}
          </Option>
        </Check>
      </div>
    </div>
  );
}
export default Page;
